import Elements from './elements';
import Layouts from './layouts';
import Icons from './icons';
import Controls from './controls';

export default {
    Elements,
    Layouts,
    Icons,
    Controls
}